import { EmploymentStatus } from '@axo/shared/data-access/types';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { MarketCountryCode } from '@axo/shared/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';

const unfilteredEmploymentStatus = (
  [
    {
      value: null,
    },
    {
      value: EmploymentStatus.Permanent,
    },
    {
      value: EmploymentStatus.PermanentPublic,
      whitelist: [{ marketCountry: [MarketCountryCode.Norway] }],
    },
    {
      value: EmploymentStatus.Temporary,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Norway,
            MarketCountryCode.Sweden,
            MarketCountryCode.Finland,
          ],
        },
      ],
    },
    {
      value: EmploymentStatus.Entrepreneur,
    },
    {
      value: EmploymentStatus.Pensioner,
    },
    {
      value: EmploymentStatus.Student,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Finland,
            MarketCountryCode.Sweden,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: EmploymentStatus.Unemployed,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Finland,
            MarketCountryCode.Sweden,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: EmploymentStatus.ParentalLeave,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: EmploymentStatus.Farmer,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: EmploymentStatus.Disabled,
      whitelist: [{ marketCountry: [MarketCountryCode.Norway] }],
    },
    {
      value: EmploymentStatus.Rehabilitation,
      whitelist: [{ marketCountry: [MarketCountryCode.Norway] }],
    },
    {
      value: EmploymentStatus.EarlyRetirement,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Axo] },
      ],
    },
    {
      value: EmploymentStatus.Hourly,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Axo] },
      ],
    },
    {
      value: EmploymentStatus.Project,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Axo] },
      ],
    },
    {
      value: EmploymentStatus.Probationary,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Axo] },
      ],
    },
    {
      value: EmploymentStatus.SickPensioner,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Axo] },
      ],
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    EmploymentStatus | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useEmploymentStatusOptions = () =>
  useApplicationConditionalFilter(unfilteredEmploymentStatus);
